import React from 'react';
import TopExperienceLayer from '../components/top/TopExperienceLayer';
import Footer from '../components/layout/Footer';
import { HeroSection } from '../components/home/HeroSection';
import { StatsRow } from '../components/home/StatsRow';
import { HowItWorks } from '../components/home/HowItWorks';
import { PortalPreview } from '../components/home/PortalPreview';
import { SignalWaves } from '../components/home/SignalWaves';
import { OzSection } from '../components/home/OzSection';
import { FirstBriefcase } from '../components/home/FirstBriefcase';
import { AudienceSection } from '../components/home/AudienceSection';
import { PartnershipsSection } from '../components/home/PartnershipsSection';
import { MediaEcosystem } from '../components/home/MediaEcosystem';
import { PartnerSchoolsSlider } from '../components/home/PartnerSchoolsSlider';

const HomePage = () => {
  return (
    <div style={{ background: '#ffffff', fontFamily: 'DM Sans, sans-serif' }} data-testid="home-page">
      <TopExperienceLayer />
      <HeroSection />
      <StatsRow />
      <HowItWorks />
      <PortalPreview />
      <SignalWaves />
      <OzSection />
      <FirstBriefcase />
      <AudienceSection />
      <PartnershipsSection />
      <MediaEcosystem />
      <PartnerSchoolsSlider />
      <Footer />
    </div>
  );
};

export default HomePage;
